import { ApplyForm, PoolForm } from "@interfaces/career"
import KyMethod from "./KyMethod"

export default class FormRepositories extends KyMethod {
  protected async storeFormApply(body: ApplyForm) {
    return this._crudPublicMethod("/career/jobs", body, { method: "post", version: "v3" })
  }

  protected async storeFormPool(body: PoolForm) {
    return this._crudPublicMethod("/career/jobs", body, { method: "post", version: "v3" })
  }

  protected async storeAssetForm(body: any) {
    return this._crudPublicMethod("/career/jobs/asset", body, {
      method: "post",
      version: "v3",
      bodyType: "form-data",
    })
  }
}
